<!-- eslint-disable no-prototype-builtins -->
<!-- eslint-disable no-restricted-syntax -->
<!-- eslint-disable camelcase -->
<template>
    <div class="section bottom-space-xl partnerCases">
        <div class="container">
            <div class="column-wrapper">
                <div class="employersWrapper column-block on-top">
                    <div class="filters">
                        <details
                            v-for="taxonomy in filteredTaxonomies" :key="taxonomy.name"
                            :class="['filtertags', taxonomy.name]"
                            :open="openFilter"
                        >
                            <summary>
                                {{ taxonomy.label }}
                                <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m8 14 4-4 4 4" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                            </summary>
                            <label v-for="term in taxonomy.terms" :key="term.term_id" :for="`checkbox-${term.term_id}`" class="w-checkbox mobile-100-percent"  :class="[{ 'checked' : selected[taxonomy.name].includes(term.term_id) }, taxonomy.name ]">
                                <div class="w-checkbox-input black w-checkbox-input--inputType-custom checkbox" :class="{ 'w--redirected-checked' : selected[taxonomy.name].includes(term.term_id) }"></div>
                                <input v-model="selected[taxonomy.name]" type="checkbox" :id="`checkbox-${term.term_id}`" :name="`checkbox-${term.term_id}`" :value="term.term_id" style="opacity:0;position:absolute;z-index:-1" @change="triggerFilter">
                                <span class="label-text in-form w-form-label" style="display: flex;gap: 8px" :for="`checkbox-${term.term_id}`">
                                            {{ term.name }}
                                            <span v-if="term.description" style="height:16px;overflow: hidden;">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM9.99 10.99V13H10.99V17H14.01V15H13L13.01 10.991L9.99 10.99ZM10.99 7V9.019H13.01V7H10.99Z" fill="currentColor"></path>
                                                </svg>
                                            </span>
                                        </span>
                                <div v-if="term.description" class="description">{{ term.description }}</div>
                            </label>
                        </details>
                        <details class="filtertags work-environment" :open="openFilter">
                            <summary>
                                Arbeitsumfeld
                                <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m8 14 4-4 4 4" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                            </summary>
                            <div class="topics" ref="topics">
                                <div
                                    v-for="term in mappedTerms" :key="term.term_id"
                                    class="topic"
                                >
                                    <switch-slider @changed="triggerFilter" :minwidth="topicsMinWidth" :terms="term.subterms"></switch-slider>
                                </div>
                            </div>
                        </details>
                    </div>

                    <div class="blog" id="employerGrid">
                        <div class="column-wrapper">
                            <h3 class="heading s cy" style="margin-top: 0">Diese Arbeitgeber passen zu Dir:</h3>
                        </div>

                        <div v-if="filteredEmployers && filteredEmployers.length > 0" class="column-wrapper employers-wrapper">
                            <employer-container v-for="employer in pagedEmployers" :key="employer.id" :employer="employer" class="employer" />
                        </div>

                        <div v-else-if="loading" class="column-wrapper">
                            <p class="basic-text">Arbeitgeber laden</p>
                        </div>
                        <div v-else class="column-wrapper">
                            <p class="basic-text">Keine Arbeitgeber zu dieser Auswahl gefunden</p>
                        </div>
                        <div v-if="totalPages > 1" class="column-wrapper">
                            <div class="vuePagination">
                                <button :class="{ 'hidden' : currentPage === 1 }" class="prev page-numbers" @click="pageBack">Vorherige Seite</button>
                                <component v-for="index in totalPages" :is="index === currentPage ? 'span' : 'a'" class="page-numbers" :class="{ 'current' : index === currentPage }" :key="index" @click="() => setPage(index)">{{ index }}</component>
                                <button :class="{ 'hidden' : currentPage === totalPages }" class="next page-numbers" @click="pageForward">Nächste Seite</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ref,
    computed,
    toRaw,
    onMounted
} from 'vue/dist/vue.esm-bundler';

import { useStore } from 'vuex';
import { watch } from 'vue';
import switchSlider from './switch.vue';
import EmployerContainer from './components/employerContainer.vue';

export default {
    name: 'EmployersFilter',
    components: {
        EmployerContainer,
        switchSlider,
    },
    props: {
        employerids: {
            type: String,
            default: null
        },
        topicterms: {
            type: String,
            default: null
        },
        headline: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const loading = ref(true);
        const store = useStore();

        const openFilter = ref(true);
        const perpage = ref(9);
        const currentPage = ref(1);
        const savedEmployers = ref(localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : []);

        const indexStart = computed(() => (currentPage.value - 1) * perpage.value);
        const indexEnd = computed(() => indexStart.value + perpage.value);

        onMounted(() => {
            setTimeout(() => {
                openFilter.value = window.innerWidth >= 1024;
            }, 1);

            window.addEventListener('resize', () => {
                if (openFilter.value && window.innerWidth < 1024) {
                    openFilter.value = false;
                } else if (!openFilter.value && window.innerWidth >= 1024) {
                    openFilter.value = true;
                }
            });
        });

        const pageBack = () => {
            currentPage.value--;
            window.bayScrollTo('employerGrid');
        };

        const pageForward = () => {
            currentPage.value++;
            window.bayScrollTo('employerGrid');
        };

        const setPage = (page) => {
            currentPage.value = page;
            window.bayScrollTo('employerGrid');
        };

        const casesToLoad = JSON.parse(props.employerids);

        const mappedTerms = computed(() => JSON.parse(props.topicterms));
        const neutralTerms = computed(() => mappedTerms.value.map((term) => {
            const neutralEntry = term.subterms.filter((item) => item.type === 'neutral');
            return neutralEntry[0].term_id;
        }));

        const selectedTopics = ref([]);

        const topicsMinWidth = computed(() => store.getters.switchMinWidth);

        const cases = ref([]);
        if (casesToLoad && casesToLoad.length) {
            store.state.api.get('/wp/v2/employers?orderby=include&per_page=99&_fields=id,partnercaseregions,benefits,partnercasetopics,acf,_links,_embedded,title,introblock,link&_embed', {
                params: { include: casesToLoad.join(',') }
            }).then((response) => {
                cases.value = response.data;
                loading.value = false;
            });
        } else {
            store.state.api.get('/wp/v2/employers?_fields=id,partnercaseregions,benefits,partnercasetopics,acf,_links,_embedded,title,introblock,link').then((response) => {
                cases.value = response.data;
                loading.value = false;
            });
        }

        const selected = ref({
            partnercase_region: [],
            employer_benefit: [],
            topics: [],
        });

        const taxonomies = ref([]);
        store.state.api.get('/baytm/v1/partnercasetaxonomies').then((response) => {
            taxonomies.value = response.data;
        });

        const areBothInArray = (a, b, array) => array.includes(a) && array.includes(b);

        const filteredTaxonomies = computed(() => taxonomies.value.filter((tax) => tax.name !== 'partnercase_topic'));

        const filteredEmployers = computed(() => {
            // pay attention to inheritance of objects
            const filtered_ = JSON.stringify(cases.value);
            let filtered = JSON.parse(filtered_);

            if (selected.value.partnercase_region.length > 0) {
                filtered = filtered.filter((c) => c.partnercaseregions.some((r) => selected.value.partnercase_region.includes(r)));
            }
            if (selected.value.employer_benefit.length > 0) {
                filtered = filtered.filter((c) => c.benefits.some((r) => selected.value.employer_benefit.includes(r)));
            }

            if (selected.value.merkliste) {
                filtered = filtered.filter((c) => savedEmployers.value.includes(c.id)); // new comment
            }

            /****  filter for topic slider ****/
            /*
            1 loop: iterate over all employers
            2 loop: iterate over our object with the current slider settings for each employer
                check if this slider setting is neutral - then always show
            3 loop: iterate over the activated term_ids of the employer and compare if this setting is false in loop 2, if yes
                and it is not the neutral state
                and if both items are in the case and neutral is not checked, show them anyway
                set entry to shown=false
            after the loops remove all .shown=false (afterwards so that the loop is not confused)
            */

            // eslint-disable-next-line no-restricted-syntax
            for (const filterItem of filtered) {
                filterItem.show = true;
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const topicItem in store.getters.selectedTopics) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (store.getters.selectedTopics.hasOwnProperty(topicItem)) {
                        const slideIsNeutral = Object.keys(store.getters.selectedTopics[topicItem]).find((key) => store.getters.selectedTopics[topicItem][key].neutral === true && store.getters.selectedTopics[topicItem][key].status === true);
                        const thisNeutral = Object.keys(store.getters.selectedTopics[topicItem]).find((key) => store.getters.selectedTopics[topicItem][key].neutral === true);
                        const oneIsNeutral = filterItem.partnercasetopics.includes(parseInt(thisNeutral, 10));
                        if (!slideIsNeutral && !oneIsNeutral) {
                            // eslint-disable-next-line no-restricted-syntax
                            for (const partnercasetopic of filterItem.partnercasetopics) {
                                // If both items are in the case and neutral is not checked, show them anyway
                                const itemNotNeutralTerms = Object.keys(store.getters.selectedTopics[topicItem]).filter((key) => store.getters.selectedTopics[topicItem][key].neutral === false);
                                const bothIn = areBothInArray(parseInt(itemNotNeutralTerms[0], 10), parseInt(itemNotNeutralTerms[1], 10), filterItem.partnercasetopics);

                                // eslint-disable-next-line no-prototype-builtins
                                if (store.getters.selectedTopics[topicItem].hasOwnProperty(partnercasetopic)
                                    && store.getters.selectedTopics[topicItem][partnercasetopic].status === false
                                    && !neutralTerms.value.includes(partnercasetopic)
                                    && !bothIn) {
                                    filterItem.show = false;
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            filtered = filtered.filter((c) => c.show === true);
            return filtered;
        });

        const pagedEmployers = computed(() => {
            if (!filteredEmployers.value) {
                return [];
            }

            return filteredEmployers.value.slice(indexStart.value, indexEnd.value);
        });

        const totalPages = computed(() => {
            if (cases.value && filteredEmployers.value.length >= 1) {
                return Math.ceil(filteredEmployers.value.length / perpage.value);
            }
            return 0;
        });

        const getTermLabelById = (termId) => {
            const topic = taxonomies.value.filter((tax) => tax.name === 'partnercase_topic')[0];
            const terms = Object.keys(toRaw(topic).terms).map((key) => toRaw(topic).terms[key]);
            const term = terms.filter((tpc) => tpc.term_id === termId)[0];
            return term.name;
        };

        const getEmployerTypeById = (termId) => {
            const topic = taxonomies.value.filter((tax) => tax.name === 'employer_type')[0];
            const term = topic.terms.filter((tpc) => tpc.term_id === termId)[0];
            return term.name;
        };

        const formatRestDate = (restDate) => {
            const numbers = restDate.split('');
            return `${numbers.slice(6, 8).join('')}.${numbers.slice(4, 6).join('')}.${numbers.slice(0, 4).join('')}`;
        };

        const formatRestTime = (restDate) => {
            const numbers = restDate.split('');
            return `${numbers.slice(0, 2).join('')}:${numbers.slice(3, 5).join('')}`;
        };

        const removeOuterHTMLpTag = (htmlString) => {
            const newString = htmlString.replace('<p>', '').replace('</p>', '');
            return newString;
        };

        const triggerFilter = () => {
            console.log('trigger Filter');
            setPage(1);
        };

        return {
            loading,
            props,
            cases,
            taxonomies,
            filteredTaxonomies,
            selected,
            getTermLabelById,
            getEmployerTypeById,
            formatRestDate,
            formatRestTime,
            filteredEmployers,
            pagedEmployers,
            removeOuterHTMLpTag,
            openFilter,
            mappedTerms,
            selectedTopics,
            totalPages,
            topicsMinWidth,
            currentPage,
            pageBack,
            pageForward,
            setPage,
            triggerFilter,
            savedEmployers,
            neutralTerms,
        };
    }
};
</script>

<style lang="scss" scoped>
.employersWrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    .blog {
        grid-column: 1/-1;

        @media screen and (min-width: 1024px) {
            grid-column: 2/-1;
        }

        .heading {
            padding-bottom: 36px;
        }

        .employers-wrapper {
            display: grid;
            grid-template-columns: 1fr;
            gap: 20px;

            @media screen and (min-width: 720px) {
                grid-template-columns: 1fr 1fr;
            }

            @media screen and (min-width: 1280px) {
                gap: 40px;
            }
        }

        .vuePagination {
            margin-top: 42px;
        }
    }
}

.filters {
    display: flex;
    flex-direction: column;
    gap: 24px;
    grid-column: 1/-1;
    margin-bottom: 24px;

    @media screen and (min-width: 1024px) {
        grid-column: 1/2;
        padding-top: 75px;
    }
}

.filtertags {
    color: #001F47;
    font-family: "CY", sans-serif;

    &:not([open]) {
        summary {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    &.partnercase_region {
        summary {
            background: rgba(14, 213, 108, 1);
        }
    }

    &.employer_benefit {
        summary {
            background: rgba(74, 115, 228, 1);
        }
    }

    &.work-environment {
        summary {
            background: rgba(143, 90, 246, 1);
        }
    }

    summary {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px 16px;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
        cursor: pointer;
    }

    label {
        margin: 0;

        &.partnercase_region {
            background: rgba(14, 213, 108, 0.08);

            &.checked {
                background: rgba(14, 213, 108, 0.16);
            }

            @media (hover: hover) and (pointer: fine) {
                &:hover {
                    background: rgba(14, 213, 108, 0.16);
                }
            }
        }

        &.employer_benefit {
            background: rgba(74, 115, 228, 0.08);

            &.checked {
                background: rgba(74, 115, 228, 0.16);
            }

            @media (hover: hover) and (pointer: fine) {
                &:hover {
                    background: rgba(74, 115, 228, 0.16);
                }
            }
        }
    }

    .label-text {
        text-transform: none !important;
        font-family: "CY Text", sans-serif;
        font-size: 18px;
        color: inherit;
        font-weight: 700;
        margin-bottom: 16px;
    }
}

label.w-checkbox {
    position: relative;
    background-color: rgba(197, 197, 197, 0.16);
    color: #001F47;
    padding: 10px 16px;
    flex-direction: row-reverse;
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 18px;
    transition: background-color .28s ease-in-out;

    & > * {
        position: relative;
        display: block;
    }

    &.checked {
        .label-text.in-form {
            font-weight: 600;
        }
    }

    .checkbox.w--redirected-checked {
        background-position: 54% 16%;
        background-size: 100%;
        background-color: transparent;
    }

    .w-checkbox-input {
        border: 0;
        margin-left: auto;

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20px;
            height: 20px;
            border: 1px solid rgba(0, 31, 71, 0.24);

        }
    }

    .w-checkbox-input:not(.w--redirected-checked) {
        background: none;
    }

    .label-text.in-form {
        margin: 0;
        color: inherit;
        width: calc(100% - 32px);
        font-size: 14px;
        font-weight: 400;
        transition: color .28s ease-in-out;
    }

    &::before {
        display: none;
    }

    .description {
        display: none;
    }

    @media (min-width: 992px) {

        &:hover {
            .description {
                display: block;
                position: absolute;
                top: calc(100% + 5px);
                max-width: 250px;
                width: 100%;
                left: 0;
                padding: 8px 16px;
                background: rgba(230, 230, 230, 1);
                color: #001F47;
                font-size: 12px;
                line-height: 17px;
                border-radius: 4px;
                z-index: 10;
            }
        }
    }
}

.filter-card.second-level-filter-card {
    display: block;
}

.cases-leave,
.cases-leave-active {
    position: absolute;
}

.cases-enter-active,
.cases-leave-active {
    transition: all 1s ease;
}

.cases-enter,
.cases-leave-to {
    opacity: 0;
    transform: translateY(30%);
}

.topics {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr 1fr;
}

.topic {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-width: 0;
    background: rgba(143, 90, 246, 0.08);

    &:not(:last-child) {
        padding-bottom: 12px;
    }

    .termName {
        padding: 10px 16px;
        font-size: 18px;
        text-align: center;
        line-height: 28px;
    }
}

.termsPill {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;
    height: 45px;
    border: 1px solid gray;
    border-radius: 75px;

    .subterm {
        display: flex;
        align-items: center;
        gap: 15px;

        &:last-child {
            flex-direction: row-reverse;
        }
    }

    input {
        appearance: none;
        width: 50px;
        height: 25px;
        border-radius: 75px;
        background-color: #4a73e4;
        opacity: 0;

        &:checked {
            opacity: 1;
        }
    }
}

button.hidden {
    display: none;
}

</style>
